import { mutations } from "@/graphql";
import { useState } from "react";
import { useMutation } from "@apollo/client/react";
export const useAddRole = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [addRole, { loading, data }] = useMutation<any>(mutations.addRole, {
    onCompleted: (response) => {
      if (response.addRole?.success || response.comAddRole?.success) {
        setSuccess(true);
        setResetForm(true);
        setTimeout(() => {
          setSuccess(false);
          setResetForm(false);
        }, 5000);
        onCompleted();
      } else {
        setSuccess(false);
      }
    },
    onError: ({ message }) => {
      setSuccess(false);
      onError(message);
    },
  });
  return {
    addRole,
    loading,
    success,
    data,
    resetForm,
  };
};
